import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Wachtwoord instellen", -1)
const _hoisted_2 = { class: "content-box" }
const _hoisted_3 = { class: "content-box" }
const _hoisted_4 = { class: "content-box" }

import {ref} from "vue";
	import {useRouter} from 'vue-router';
	import {FetchToken} from "../utils/FetchData";
	import emitter from '../main';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPasswordPage',
  setup(__props) {

	const email = ref('');
	const password = ref('');
	const confirm = ref('');
	const router = useRouter();

	const errorEmail = ref('');
	const errorPassword = ref('');

	async function setPassword() {
		const query = router.currentRoute.value.query;
		const token = query.token || '';

		const body = new URLSearchParams({
			email: email.value,
			password: password.value,
			password_confirmation: confirm.value,
			token: token as string
		});

		errorEmail.value = '';
		errorPassword.value = '';

		const data = await FetchToken('reset-password', body, true);
		if(!data.isError) {
			router.replace('/login');
			emitter.emit('showMessage', {message: 'Het nieuwe wachtwoord is opgeslagen', header: 'Gelukt'});
			return;
		}

		if(data.errors != undefined) {
			if(data.errors.email != undefined)
				errorEmail.value = data.errors.email[0];
			if(data.errors.password != undefined)
				errorPassword.value = data.errors.password[0];
		}
		else if(data.status == 400) {
			emitter.emit('showMessage', {message: data.msg, header: 'Error'});
		}
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Email",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
      }, null, 512), [
        [_vModelText, email.value]
      ])
    ]),
    _createElementVNode("p", {
      class: _normalizeClass(["error no-margin", {hidden: errorEmail.value.length == 0}])
    }, _toDisplayString(errorEmail.value), 3),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        type: "password",
        placeholder: "Wachtwoord",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event))
      }, null, 512), [
        [_vModelText, password.value]
      ])
    ]),
    _createElementVNode("p", {
      class: _normalizeClass(["error no-margin", {hidden: errorPassword.value.length == 0}])
    }, _toDisplayString(errorPassword.value), 3),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        type: "password",
        placeholder: "Wachtwoord herhalen",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirm).value = $event))
      }, null, 512), [
        [_vModelText, confirm.value]
      ])
    ]),
    _createElementVNode("button", {
      class: "content-box",
      onClick: setPassword
    }, " Wachtwoord instellen ")
  ], 64))
}
}

})